export default            
	{
        path:'/explore',
        name:'外部探索',
        redirect:'/explore/main',
        component:()=>import('../views/explore/index'),
        meta:{requireAuth:true,roles:['student']},
        children:[
            {
                path:'/explore/main',
                name:'外部探索主页',
                component:()=>import('../views/explore/main'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/explore/informationDetail',
                name:'资讯详情页',
                component:()=>import('../views/explore/informationDetail'),
                meta:{requireAuth:true,roles:['student']},
            },
            // 院校库
            {
                path: '/explore/yuanxiaoku',
                name: '院校库列表',
                component:()=>import('../views/explore/yuanxiaoku/yuanxiaoku.vue'),
                meta: { keepAlive: true ,requireAuth:true,roles:['student']},
            },
            // 自招院校库
            {
                path: '/explore/zizhaoyuanxiaoku',
                name: '自招院校库列表',
                component: () => import('../views/explore/zizhaoxuexiaoku/zizhaoxuexiaoku.vue'),
                meta: {requireAuth: true, roles: ['student']}
            },
            {
                path: '/explore/yuanxiaoxiangqing',
                name: '院校详情',
                component:()=>import('../views/explore/yuanxiaoku/yuanxiaoxiangqing.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/explore/zhaoshengjianzhang',
                name: '招生简章',
                component:()=>import('../views/explore/yuanxiaoku/zhaoshengjianzhang.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/explore/yuanxiaoduibi',
                name: '院校对比',
                component:()=>import('../views/explore/yuanxiaoku/yuanxiaoduibi.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            // 专业库
            {
                path: '/explore/zhuanyeku',
                name: '专业库列表',
                component:()=>import('../views/explore/zhuanyeku/zhuanyeku.vue'),
                meta: { keepAlive: true,requireAuth:true,roles:['student'] },
            },
            {
                path: '/explore/zhuanyexiangqing',
                name: '专业详情',
                component:()=>import('../views/explore/zhuanyeku/zhuanyexiangqing.vue'),
                meta: { keepAlive: true,requireAuth:true,roles:['student']}
            },
            // 职业库
            {
                path: '/explore/zhiyeku',
                name: '职业库列表',
                component:()=>import('../views/explore/zhiyeku/zhiyeku.vue'),
                meta: { keepAlive: true,requireAuth:true,roles:['student'] },
            },
            {
                path: '/explore/zhiyexiangqing',
                name: '职业详情',
                component:()=>import('../views/explore/zhiyeku/zhiyexiangqing.vue'),
                meta: { keepAlive: true,requireAuth:true,roles:['student'] },
            },
            // {
            //     path: '/explore/myCollection',
            //     name: '我的收藏',
            //     component:()=>import('../views/explore/myCollection/myCollection.vue'),
            //     meta:{requireAuth:true,roles:['student']},
            // },
            {
                    path: '/explore/myCollection',
                    name: '高中竞赛库',
                    component:()=>import('../views/explore/myCollection/myCollection.vue'),
                    meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/explore/competition',
                name: '竞赛详情',
                component:()=>import('../views/explore/myCollection/competition.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/explore/competitionVideoList',
                name: '指导视频',
                component:()=>import('../views/explore/myCollection/competitionVideoList.vue'),
                meta:{requireAuth:true,roles:['student']},
            },

            //学科评估
            {
                path: '/explore/xuekepinggu',
                component:()=>import('../views/explore/xuekepinggu/xuekepinggu.vue') ,
                children:[
                    {
                        path: '/explore/xuekepinggu/xuekeuniversity',
                        component:()=>import('../views/explore/xuekepinggu/xuekeuniversity.vue'),
                        meta:{requireAuth:true,roles:['student']},
                    },
                    {
                        path: '/explore/xuekepinggu/xuekesubject',
                        component:()=>import('../views/explore/xuekepinggu/xuekesubject.vue'),
                        meta:{requireAuth:true,roles:['student']},
                    }
                ]
            },
            {
                path: '/explore/gaokaobaike',
                name: '高考百科',
                component:()=>import('../views/explore/gaokaobaike/gaokaobaike.vue'),
                meta: { keepAlive: true,requireAuth:true,roles:['student'] },
            },
            {
                path: '/explore/baikexiangqing',
                name: '百科详情',
                component:()=>import('../views/explore/gaokaobaike/baikexiangqing.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
        ]
    }